// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalFilter_root__3xkYG","footer":"ModalFilter_footer__241uY"};